import { render, staticRenderFns } from "./todayorders.vue?vue&type=template&id=66cf7186&scoped=true"
import script from "./todayorders.vue?vue&type=script&lang=js"
export * from "./todayorders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf7186",
  null
  
)

export default component.exports